/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".request-header[_ngcontent-%COMP%]{padding-bottom:10px}.box[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.request-number-title[_ngcontent-%COMP%]{margin-left:.25em}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/review-request-page/review-request-page.component.css.shim.ngstyle.js.pre-build-optimizer.js